module.exports = __webpack_public_path__ + "static/img/9.049a9ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/btn2/9.jpg
// module id = glrv
// module chunks = 0